const CryptoJS = require('crypto-js');

const CryptoSecret = '__CryptoJS_Secret__';

/**
 * Encrypt data
 * @param data - Data
 */
export const encrypto = (data) => {
    const dataTemp = data['value'];
    if (dataTemp instanceof Map) {
        const obj = {};
        let num = 0;
        for (let [k, v] of dataTemp) {
            obj[k] = v;
            num = num + 1;
            if (num === dataTemp.size) {
                data.value = obj;
                const newData = JSON.stringify(data);
                return CryptoJS.AES.encrypt(newData, CryptoSecret).toString();
            }
        }
    } else {
        const newData = JSON.stringify(data);
        return CryptoJS.AES.encrypt(newData, CryptoSecret).toString();
    }
}

/**
 * Decrypt data
 * @param cipherText - Cipher text
 */
export const decrypto = (cipherText) => {
    const bytes = CryptoJS.AES.decrypt(cipherText, CryptoSecret);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    if (originalText) {
        return JSON.parse(originalText);
    }
    return null;
}